import { RootState } from '../../model/model'
import { TroubleShootingContent } from '../../model/troubleShooting'

export const selectTroubleShootingLogin = (state: RootState): TroubleShootingContent => state.troubleShooting.login
export const selectTroubleShootingDataTransfer = (state: RootState): TroubleShootingContent => state.troubleShooting.dataTransfer
export const selectTroubleShootingVideoConference = (state: RootState): TroubleShootingContent => state.troubleShooting.videoConference
